import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Page from 'Components/Page';
import { useForm } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import * as actions from 'Store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import history from '../history';
import { toBase64 } from '../helpers';
import FormTextField from 'Components/FormTextField';
import FileUpload from 'Components/Dropzone/FileUpload';
import Loading from 'Components/Loading';
import uuid from 'uuid';
import * as Regex from '../regex';

const pageStyles = theme => ({
  pageWrapper: {
    paddingLeft: '3%',
    paddingRight: '3%',
  },
  addEditForm: {
    display: 'flex',
    flexDirection: 'column',
  },
  optionalMessage: {
    fontSize: 18,
  },
  button: {
    alignSelf: 'flex-start',
    marginTop: '90px',
  },
  photoContainer: {
    marginBottom: '40px',
  },
});

function AddEditProduct({ classes, itemDraft, saveImagesLocally, saveItemDraftInfo, checkoutReset, updateItem, path }) {
  const { register, handleSubmit, errors } = useForm({
    defaultValues: {
      ...itemDraft.info,
    },
  });

  const [loading, setLoading] = useState(false);

  const isEdit = path === '/edit-item' ? true : false;

  //Todo: this needs to be in useEffect maybe, doesn't seem to be working
  checkoutReset();

  const onSubmit = async data => {
    setLoading(true);
    const _item = {
      ...itemDraft,
      info: {
        ...itemDraft.info,
        ...data,
      },
    };

    if (isEdit) {
      await updateItem(_item);
      history.push('/dashboard');
    } else {
      await saveItemDraftInfo(data);
      history.push('/checkout');
    }
  };

  function serializeImagesForDropzone(images = []) {
    return images.map(image => ({
      preview: image,
    }));
  }

  async function cropImages(images, setWidth) {
    // inspired from here: https://zocada.com/compress-resize-images-javascript-browser/

    let promisesArr = [];
    let croppedImageBlobs = [];

    images.forEach(localImage => {
      promisesArr.push(
        new Promise((resolve, reject) => {
          const fileName = uuid.v4();
          var url = URL.createObjectURL(localImage);

          const img = new Image();
          img.src = url;
          return (img.onload = () => {
            const elem = document.createElement('canvas');
            const ctx = elem.getContext('2d');
            const width = setWidth;
            const scaleFactor = width / img.width;
            elem.width = width;
            elem.height = img.height * scaleFactor;
            ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
            ctx.canvas.toBlob(
              blob => {
                const file = new File([blob], fileName, {
                  type: 'image/jpeg',
                  lastModified: Date.now(),
                });
                croppedImageBlobs.push(file);
                resolve(file);
              },
              'image/jpeg',
              0.95,
            );
          });
        }),
      );
    });

    return Promise.all(promisesArr)
      .then(res => {
        return croppedImageBlobs;
      })
      .catch(err => {
        console.warn('Error resizing images on page: ', err);
      });
  }

  async function getImagesBase64(images) {
    const imagesBase64 = [];
    for (const image of images) {
      let imageBase64;

      if (image instanceof File) {
        // Image in Dropzone is a File object
        imageBase64 = await toBase64(image);
      } else if (image.preview) {
        // Image in Dropzone is an object with a preview property containing the base64 of the image
        imageBase64 = image.preview;
      } else {
        // Image in Dropzone is a base64
        imageBase64 = image;
      }

      imagesBase64.push(imageBase64);
    }

    return imagesBase64;
  }

  function getPhoneHelpertext() {
    if (errors.phone) {
      return errors.phone.message;
    }

    return `If provided text messages will be sent here regarding lost items. `;
  }

  function getEmailHelpertext() {
    if (errors.email) {
      return errors.email.message;
    }

    return `Notifications from this tag will be sent here.`;
  }

  return (
    <Page wrapperStyles={classes.pageWrapper}>
      {loading ? (
        <Loading
          type={'bubbles'}
          color={'#ccc'}
          height={'80px'}
          width={'80px'}
          containerHeight={'40vh'}
          containerWidth={'100%'}
          message={'Updating...'}
        />
      ) : (
        <>
          <Typography variant="h1">{isEdit ? `Edit Tag: ${itemDraft.info.itemId}` : 'Contact for this tag'}</Typography>
          <FormHelperText>
            Your email and phone number will always be kept private and we will relay messages to you.
          </FormHelperText>
          <form onSubmit={handleSubmit(onSubmit).bind(this)} className={classes.addEditForm}>
            {/* <FormTextField
              fullWidth
              label="Tag Set Name (e.g. Tom's Stuff)"
              name="name"
              required
              error={!!errors.name}
              helperText={errors.name && errors.name.message}
              inputRef={register({ required: 'Name this tag' })}
              placeholder="Enter Name"
            /> */}

            {/* <FormControl className={classes.photoContainer}>
              <InputLabel
                style={{
                  position: 'relative',
                  marginTop: '50px',
                  top: '-35px',
                  marginBottom: '10px',
                }}
              >
                Photos{' '}
                <span className={classes.optionalMessage}>(optional)</span>
              </InputLabel> */}
            {/* <Dropzone
                onChange={async images => {
                  if (images.length === 0) {
                    saveImagesLocally([]);
                  }

                  const resizedMainImages = await cropImages(images, 1000);
                  const resizedThumbImages = await cropImages(images, 300);

                  const imagesBase64 = await getImagesBase64(resizedMainImages);
                  const imagesBase64Thumbs = await getImagesBase64(
                    resizedThumbImages,
                  );

                  saveImagesLocally({
                    main: imagesBase64,
                    thumbs: imagesBase64Thumbs,
                  });
                }}
                initialFiles={serializeImagesForDropzone(itemDraft.images)}
                isFullPreviewSupported
                maxNumFiles={2}
                isMultipleFilesAllowed={false}
                contentUnderUploadArea={
                  <FormHelperText>Please upload only one photo</FormHelperText>
                }
              /> */}
            {/* <FileUpload
                onChange={async (images) => {
                  if (images.length === 0) {
                    saveImagesLocally([]);
                  }

                  const resizedMainImages = await cropImages(images, 1000);
                  const resizedThumbImages = await cropImages(images, 300);

                  const imagesBase64 = await getImagesBase64(resizedMainImages);
                  const imagesBase64Thumbs = await getImagesBase64(
                    resizedThumbImages,
                  );

                  saveImagesLocally({
                    main: imagesBase64,
                    thumbs: imagesBase64Thumbs,
                  });
                }}
                initialFiles={serializeImagesForDropzone(itemDraft.info.images)}
              />
            </FormControl> */}

            <FormTextField
              fullWidth
              label="Contact Email"
              name="email"
              required
              error={!!errors.email}
              helperText={getEmailHelpertext()}
              inputRef={register({
                required: 'Provide the contact email',
                pattern: {
                  value: Regex.email,
                  message: 'Provide a valid email address',
                },
              })}
              placeholder="Enter Contact Email"
            />

            <FormTextField
              fullWidth
              label="Contact Phone normal"
              name="phone"
              error={!!errors.phone}
              helperText={getPhoneHelpertext()}
              inputRef={register}
              placeholder="Enter Phone Number"
            />

            <FormTextField
              fullWidth
              label="Message"
              name="message"
              error={!!errors.message}
              helperText={errors.message ? errors.message.message : 'Add an optional message to display.'}
              inputRef={register({
                required: false,
              })}
              placeholder="Enter Message"
              multiline
            />

            <Button type="submit" variant="contained" color="primary" className={classes.button}>
              {isEdit ? 'Update Tag' : 'Continue'}
            </Button>

            <FormHelperText>*Required</FormHelperText>
          </form>
        </>
      )}
    </Page>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveImagesLocally: actions.saveImagesLocally,
      saveItemDraftInfo: actions.saveItemDraftInfo,
      checkoutReset: actions.checkoutReset,
      updateItem: actions.updateItem,
    },
    dispatch,
  );
}

function mapStateToProps({ itemDraft }, ownProps) {
  return {
    itemDraft,
    path: ownProps.location.pathname,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(pageStyles)(AddEditProduct)));
